import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faFilter } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Divider, Pagination, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import moment from 'moment';
import { ChangeEvent, useEffect, useState } from 'react';
import FilterSelect from '../../../components/FilterSelect';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { FilterInterface } from '../../../interfaces/entities/FilterInterface';
import { ExameGrupo } from '../../../interfaces/entities/ResultadoExame/ExameGrupo';
import { OrderingGroupExamsEnum } from '../../../interfaces/enum/OrderingGroupExamsEnum';
import { getResultadoExameGrupo } from '../../../services/ResultadoExamesServices';
import { getDayName } from '../../../utils/DateFormat';
import ExamCard from './ExamCard';
import { orderingOptionsDefault } from './defaultStates';
import './styles.css';
import { sxButtonText, sxCalendar, sxCalendarContrast, sxLabel, sxPagination } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { sxPaginationContrast } from '../../../assets/styles/CommonSxProps';
import { scrollTo } from '../../../utils/ScrollUtil';
import PageTitle from '../../../components/Accessibility/PageTitle';
import DateInput from '../../../components/DateInput';

const ResultadoExames = () => {

  const [typeExam, setTypeExam] = useState<FilterInterface[]>([]);

  const [groupExams, setGroupExams] = useState<ExameGrupo[]>([]);
  const [groupExamsFiltered, setGroupExamsFiltered] = useState<ExameGrupo[]>([]);
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const paginationLength = 5;
  const [orderingOptions, setOrderingOptions] = useState<FilterInterface[]>(orderingOptionsDefault);
  const [modalFeedback, setmodalFeedback] = useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);
  const [typeSelected, setTypeSelected] = useState<string>("");
  const [orderSelected, setOrderSelected] = useState<string>("Mais recente");
  const [eraseFilters, setEraseFilters] = useState<boolean>(false);
  const [dataInicio, setDataInicio] = useState<Dayjs | null>();
  const [dataFim, setDataFim] = useState<Dayjs | null>();

  const accessibility = useAccessibility();

  useEffect(() => {
    getGroupExams();
  }, [])

  var getGroupExams = async () => {
    setLoading(true);
    var response = await getResultadoExameGrupo();
    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: 'Falha ao buscar exames.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setLoading(false);
      return;
    }
    getTypeGroupExams(response.data);
    setGroupExams(response.data.sort(sortByDate));
    setGroupExamsFiltered(response.data.sort(sortByDate));
    setLoading(false);
  };

  const sortByDate = (a: ExameGrupo, b: ExameGrupo) => {
    let dataA = new Date(a.dataHoraLibera.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")).getTime();
    let dataB = new Date(b.dataHoraLibera.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")).getTime();
    return dataB - dataA;
  }

  const getTypeGroupExams = (groupExams: ExameGrupo[]) => {
    const typeExamsList: FilterInterface[] = [];
    groupExams.forEach((g) => {
      var descricao = g.descrLoinc.substring(0, g.descrLoinc.indexOf('(')).trim();
      descricao = descricao || g.descrLoinc.replace(/\n/g, '')
      const tipoExistente = typeExamsList.some(item => item.descricao === descricao);
      if (!tipoExistente) {
        typeExamsList.push({ descricao: descricao || g.descrLoinc.replace(/\n/g, ''), id: g.descrLoinc });
      }
    });

    setTypeExam(typeExamsList);
  };


  const paginatedExam = groupExamsFiltered.slice(
    (page - 1) * paginationLength,
    page * paginationLength
  );


  const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
    scrollTo('scroll-ref');
  };

  const handleType = (value: string) => {
    setPage(1);
    const filteredGroups = groupExams.filter(g => g.descrLoinc === value);
    setGroupExamsFiltered(filteredGroups);
  }

  const handleSort = (value: string) => {
    const swap = groupExamsFiltered.filter(() => true);
    switch (value) {
      case OrderingGroupExamsEnum.MaisAntigo:
        const ordenedAsc = swap.sort((a, b) => {
          const nameA = new Date(a.dataHoraLibera.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")).getTime();
          const nameB = new Date(b.dataHoraLibera.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")).getTime();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        setGroupExamsFiltered(ordenedAsc)
        break;

      case OrderingGroupExamsEnum.MaisRecente:
        const ordenedDesc = swap.sort((a, b) => {
          const nameA = new Date(a.dataHoraLibera.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")).getTime();
          const nameB = new Date(b.dataHoraLibera.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")).getTime();

          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }
          return 0;
        });
        setGroupExamsFiltered(ordenedDesc)
        break;

      default:
        break;
    }
  };

  const handleClearFilters = () => {
    setGroupExamsFiltered(groupExams);
    setTypeSelected('');
    setOrderSelected('Mais recente');
    setEraseFilters(!eraseFilters);
    setDataInicio(null);
    setDataFim(null);
  };

  dayjs.locale('pt-br');

  const stringToDate = (date: string): Date => {
    const partes = date.split('/');
    const dia = parseInt(partes[0], 10);
    const mes = parseInt(partes[1], 10) - 1;
    const ano = parseInt(partes[2], 10);
    return new Date(ano, mes, dia);
  }

  const handleDateChangeIni = (date: Dayjs | null) => {
    if (date !== null) {
      setDataInicio(date);
      var _groupExamsFiltered;
      if (dataFim) {
        _groupExamsFiltered = groupExams.filter(g => stringToDate(g.dataHoraLibera) >= date.toDate() && stringToDate(g.dataHoraLibera) <= dataFim.toDate())
        setGroupExamsFiltered(_groupExamsFiltered);
      } else {
        _groupExamsFiltered = groupExams.filter(g => stringToDate(g.dataHoraLibera) >= date.toDate())
        setGroupExamsFiltered(_groupExamsFiltered);
      }

    }
  }
  const handleDateChangeFim = (date: Dayjs | null) => {
    if (date !== null) {
      setDataFim(date);
      var _groupExamsFiltered;
      if (dataInicio) {
        _groupExamsFiltered = groupExams.filter(g => stringToDate(g.dataHoraLibera) >= dataInicio.toDate() && stringToDate(g.dataHoraLibera) <= date.toDate())
        setGroupExamsFiltered(_groupExamsFiltered);
      } else {
        _groupExamsFiltered = groupExams.filter(g => stringToDate(g.dataHoraLibera) <= date.toDate())
        setGroupExamsFiltered(_groupExamsFiltered);
      }
    }
  }


  return (
    <div className='container-exam'>
      <LoadingApp showLoading={loading} />
      <PageTitle text="Resultados de exames" />
      <Typography className='container-subtitle' style={accessibility.textStyleAccessibility}>Confira os resultados disponíveis.</Typography>
      <Divider />
      <div className='filter-holder-exam' id='scroll-ref'>
        <h1 className='filter-title' style={accessibility.textStyleAccessibility}><FontAwesomeIcon icon={faFilter as IconDefinition} />&nbsp;Filtrar resultados</h1>
        <div className="filter-row">
          <div className="filter-option">
            <FilterSelect title='Tipo de exame' value={typeSelected} options={typeExam} disabled={false} handleChange={handleType} erase={eraseFilters} />
          </div>
          <div className="filter-option">
            <FilterSelect value={orderSelected} title='Ordenar por' options={orderingOptions} disabled={false} handleChange={handleSort} erase={eraseFilters} />
          </div>

        </div>
        <div className="filter-row">
          <div className="filter-option">
            <Typography style={accessibility.textStyleAccessibility} sx={sxLabel}>Data Início</Typography>
            <DateInput
              label={`Data início`}
              onChange={handleDateChangeIni}
              maxDate={dayjs()}
            />
          </div>
          <div className="filter-option">
            <Typography sx={sxLabel} style={accessibility.textStyleAccessibility}>Data Fim</Typography>
            <DateInput
              label={`Data fim`}
              onChange={handleDateChangeFim}
              maxDate={dayjs()}
            />
          </div>
          <div className="clean-filter-button-holder-exam">
            <Button onClick={handleClearFilters}>
              <Typography sx={sxButtonText} style={{...accessibility.textStyleAccessibility, color: '#00995D'}}>Limpar filtros</Typography>
            </Button>
          </div>
        </div>
      </div>
      <Divider />
      <div>
        {groupExams.length === 0 ?
          <h1 className='empty-notifications' style={accessibility.textStyleAccessibility} tabIndex={0}>Você ainda não possui resultados de exames disponíveis.</h1>
          :
          <div>
            {paginatedExam.map((examGroup, index) => (
              <ExamCard key={index} examGroup={examGroup} page={page}/>
            ))}
          </div>
        }
      </div>
      {groupExamsFiltered.length > 5 &&
        <div className='pagination-holder'>
          <Pagination
            count={Math.ceil(groupExamsFiltered.length / 5)}
            sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination} hideNextButton hidePrevButton
            color='primary'
            page={page}
            onChange={handlePageChange}
          />
        </div>
      }
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        showButtonModal
        handleButtonModal={modalFeedback?.action}
      />
    </div>
  )
}

export default ResultadoExames